'use client';

import { c as _c } from "react/compiler-runtime";
import { directPurchaseQuantity, formatFiatUnits } from '@morfi/onramp-sdk';
import type { FundingCheckout } from '@morfi/onramp-sdk/react';
import { useLocale, useTranslations } from 'next-intl';
import type { JSX } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { FundingFees } from './amount/funding-fees';
export function FundingCardReview(t0) {
  const $ = _c(82);
  const {
    checkout
  } = t0;
  const t = useTranslations("onramp");
  const locale = useLocale();
  const review = checkout.review;
  if (!review) {
    return null;
  }
  const estimate = review.estimate;
  let t1;
  if ($[0] !== estimate.currency || $[1] !== estimate.decimals || $[2] !== estimate.principalUnits || $[3] !== locale) {
    t1 = formatFiatUnits(estimate.principalUnits, estimate.decimals, estimate.currency, locale);
    $[0] = estimate.currency;
    $[1] = estimate.decimals;
    $[2] = estimate.principalUnits;
    $[3] = locale;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <p className="text-display text-center">{t1}</p>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t) {
    t3 = t("you_receive");
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <dt>{t3}</dt>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== checkout.purchase || $[12] !== estimate.currency || $[13] !== estimate.decimals || $[14] !== estimate.principalUnits || $[15] !== estimate.receivedLocalUnits || $[16] !== locale || $[17] !== review.receivedUnits) {
    t5 = checkout.purchase ? directPurchaseQuantity(checkout.purchase, review.receivedUnits, locale) : formatFiatUnits(estimate.receivedLocalUnits ?? estimate.principalUnits, estimate.decimals, estimate.currency, locale);
    $[11] = checkout.purchase;
    $[12] = estimate.currency;
    $[13] = estimate.decimals;
    $[14] = estimate.principalUnits;
    $[15] = estimate.receivedLocalUnits;
    $[16] = locale;
    $[17] = review.receivedUnits;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t5) {
    t6 = <dd className="text-right">{t5}</dd>;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t) {
    t7 = t("destination");
    $[21] = t;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t7) {
    t8 = <dt>{t7}</dt>;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t) {
    t9 = t("morfi_wallet");
    $[25] = t;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t9) {
    t10 = <dd className="text-right">{t9}</dd>;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t) {
    t11 = t("payment_method");
    $[29] = t;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t11) {
    t12 = <dt>{t11}</dt>;
    $[31] = t11;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== checkout.selectedCard || $[34] !== t) {
    t13 = checkout.selectedCard ? t("saved_card_label", {
      brand: checkout.selectedCard.brand,
      last4: checkout.selectedCard.last4
    }) : t("card");
    $[33] = checkout.selectedCard;
    $[34] = t;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== t13) {
    t14 = <dd className="text-right">{t13}</dd>;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== t10 || $[39] !== t12 || $[40] !== t14 || $[41] !== t4 || $[42] !== t6 || $[43] !== t8) {
    t15 = <dl className="grid grid-cols-2 gap-3 text-body">{t4}{t6}{t8}{t10}{t12}{t14}</dl>;
    $[38] = t10;
    $[39] = t12;
    $[40] = t14;
    $[41] = t4;
    $[42] = t6;
    $[43] = t8;
    $[44] = t15;
  } else {
    t15 = $[44];
  }
  const t16 = estimate.targetUnits ?? estimate.principalUnits;
  let t17;
  if ($[45] !== checkout.purchase || $[46] !== review) {
    t17 = checkout.purchase ? {
      purchase: checkout.purchase,
      purchaseReview: review
    } : {};
    $[45] = checkout.purchase;
    $[46] = review;
    $[47] = t17;
  } else {
    t17 = $[47];
  }
  let t18;
  if ($[48] !== estimate || $[49] !== review.limits || $[50] !== t16 || $[51] !== t17) {
    t18 = <FundingFees currency={estimate.currency} decimals={estimate.decimals} principalUnits={t16} estimate={estimate} limits={review.limits} {...t17} />;
    $[48] = estimate;
    $[49] = review.limits;
    $[50] = t16;
    $[51] = t17;
    $[52] = t18;
  } else {
    t18 = $[52];
  }
  let t19;
  if ($[53] !== t) {
    t19 = t("total_charged");
    $[53] = t;
    $[54] = t19;
  } else {
    t19 = $[54];
  }
  let t20;
  if ($[55] !== t19) {
    t20 = <span>{t19}</span>;
    $[55] = t19;
    $[56] = t20;
  } else {
    t20 = $[56];
  }
  let t21;
  if ($[57] !== estimate.currency || $[58] !== estimate.decimals || $[59] !== estimate.totalUnits || $[60] !== locale) {
    t21 = formatFiatUnits(estimate.totalUnits, estimate.decimals, estimate.currency, locale);
    $[57] = estimate.currency;
    $[58] = estimate.decimals;
    $[59] = estimate.totalUnits;
    $[60] = locale;
    $[61] = t21;
  } else {
    t21 = $[61];
  }
  let t22;
  if ($[62] !== t21) {
    t22 = <span>{t21}</span>;
    $[62] = t21;
    $[63] = t22;
  } else {
    t22 = $[63];
  }
  let t23;
  if ($[64] !== t20 || $[65] !== t22) {
    t23 = <div className="flex justify-between text-body">{t20}{t22}</div>;
    $[64] = t20;
    $[65] = t22;
    $[66] = t23;
  } else {
    t23 = $[66];
  }
  const t24 = checkout.busy || review.state !== "ready";
  const t25 = checkout.busy;
  let t26;
  if ($[67] !== checkout) {
    t26 = () => {
      checkout.pay();
    };
    $[67] = checkout;
    $[68] = t26;
  } else {
    t26 = $[68];
  }
  let t27;
  if ($[69] !== t) {
    t27 = t("pay");
    $[69] = t;
    $[70] = t27;
  } else {
    t27 = $[70];
  }
  let t28;
  if ($[71] !== checkout.busy || $[72] !== t24 || $[73] !== t26 || $[74] !== t27) {
    t28 = <AnimatedButton disabled={t24} loading={t25} onClick={t26}>{t27}</AnimatedButton>;
    $[71] = checkout.busy;
    $[72] = t24;
    $[73] = t26;
    $[74] = t27;
    $[75] = t28;
  } else {
    t28 = $[75];
  }
  let t29;
  if ($[76] !== t15 || $[77] !== t18 || $[78] !== t2 || $[79] !== t23 || $[80] !== t28) {
    t29 = <div className="flex flex-col gap-4">{t2}{t15}{t18}{t23}{t28}</div>;
    $[76] = t15;
    $[77] = t18;
    $[78] = t2;
    $[79] = t23;
    $[80] = t28;
    $[81] = t29;
  } else {
    t29 = $[81];
  }
  return t29;
}